import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const styles = {
  container: {
    maxWidth: 800,
    margin: "40px auto",
    padding: 24,
    background: "#f7fafd",
    borderRadius: 18,
    boxShadow: "0 2px 16px #bbdefb22",
    fontFamily: "inherit"
  },
  heading: {
    fontSize: 32,
    color: "#2d62ee",
    fontWeight: 700,
    letterSpacing: 0.3,
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  note: {
    color: "#946600",
    background: "#fff7df",
    padding: "4px 12px",
    borderRadius: 8,
    fontWeight: 500,
    display: "inline-block",
    fontSize: 15,
    marginBottom: 18,
    marginTop: 0,
  },
  form: {
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 1px 6px #0d47a11a",
    display: "flex",
    flexDirection: "column",
    gap: 18,
    marginBottom: 32,
    transition: "box-shadow 0.25s"
  },
  fieldRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 14,
    alignItems: "flex-end"
  },
  label: {
    fontWeight: 600,
    color: "#3949ab",
    marginBottom: 3
  },
  input: {
    padding: "9px 12px",
    borderRadius: 9,
    border: "2px solid #bbdefb",
    fontSize: 16,
    width: 250,
    transition: "border 0.2s",
    outline: "none"
  },
  inputFocus: {
    border: "2px solid #1976d2"
  },
  btn: {
    padding: "9px 26px",
    border: "none",
    borderRadius: 9,
    fontWeight: 600,
    fontSize: 17,
    background: "linear-gradient(90deg,#3f51b5 60%,#1976d2 100%)",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 1px 5px #1976d211",
    transition: "background 0.2s, transform 0.1s",
    marginLeft: 10,
    marginTop: 6
  },
  btnDanger: {
    background: "linear-gradient(90deg,#f44336 60%,#c62828 100%)",
    color: "#fff",
    border: "none"
  },
  btnCancel: {
    background: "#ececec",
    color: "#444",
    border: "none"
  },
  previewUser: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    background: "#e8f0ff",
    padding: "7px 15px",
    borderRadius: 10,
    marginTop: 6,
    fontWeight: 500,
    fontSize: 15
  },
  previewImg: {
    width: 45,
    height: 45,
    borderRadius: "50%",
    border: "2px solid #bbdefb",
    objectFit: "cover"
  },
  error: {
    color: "#e53935",
    background: "#fff2f2",
    fontWeight: 600,
    padding: "6px 12px",
    borderRadius: 8,
    marginTop: 7,
    fontSize: 16
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 1px 6px #0d47a11a",
    overflow: "hidden"
  },
  th: {
    background: "#e3f0fd",
    color: "#333",
    padding: "14px 9px",
    fontWeight: 700,
    fontSize: 15,
    textAlign: "left",
    borderBottom: "1.5px solid #cfd8dc"
  },
  td: {
    padding: "13px 8px",
    fontSize: 15,
    borderBottom: "1px solid #f1f6fa"
  },
  trEven: {
    background: "#f8fbff",
    transition: "background 0.3s"
  },
  trOdd: {
    background: "#fff",
    transition: "background 0.3s"
  }
};

export default function RemovedRanking() {
  const [searchUserId, setSearchUserId] = useState("");
  const [searchedUser, setSearchedUser] = useState(null);
  const [userIdToRemove, setUserIdToRemove] = useState(null);
  const [remRanks, setRemRanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [inputFocus, setInputFocus] = useState(false);

  // Fetch table data
  const getDataOfCoinPanel = async () => {
    setFetching(true);
    try {
      const { data } = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familyImage/getRemovedRanks`
      );
      setRemRanks(data.details || []);
    } catch (error) {
      toast.error(error.message);
    }
    setFetching(false);
  };

  useEffect(() => {
    getDataOfCoinPanel();
  }, []);

  // Search user
  const checkuser = async () => {
    setSearchedUser(null);
    setUserIdToRemove(null);
    if (!searchUserId) return toast.warning("Please enter username or UserID");
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL1}/coin/recharge/sendCoinfetchuser?userId=${searchUserId}`
      );
      if (res?.data?.success === 1 && res?.data?.details?.username) {
        setSearchedUser(res.data.details);
        setUserIdToRemove(res.data.details._id);
      } else {
        setSearchedUser("notfound");
      }
    } catch (e) {
      setSearchedUser("notfound");
      toast.error(e.message);
    }
    setLoading(false);
  };

  // Add user
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!userIdToRemove) return toast.warning("No user selected");
    setLoading(true);
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familyImage/createRemovedRanks?id=${userIdToRemove}`
      );
      if (data.success === 1) toast.success(data.message);
      else toast.error(data.message);
      setSearchUserId("");
      setSearchedUser(null);
      setUserIdToRemove(null);
      getDataOfCoinPanel();
    } catch (err) {
      toast.error(err.message);
    }
    setLoading(false);
  };

  // Delete user
  const deleteRemovedRanks = async (id) => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.delete(
        `${process.env.REACT_APP_BASEURL5}/admin/familyImage/deleteRemovedRanks?id=${id}`
      );
      if (data.success === 1) toast.success(data.message);
      else toast.error(data.message);
      getDataOfCoinPanel();
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.heading}>
        <span role="img" aria-label="test">🧪</span> Create Test User
      </div>
      <div style={styles.note}>
        Note: Test Users will <b>NOT</b> appear in Balance, Send or Receive Ranking
      </div>
      <form
        style={styles.form}
        autoComplete="off"
        onSubmit={handleAdd}
      >
        <div style={styles.fieldRow}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={styles.label}>Username / Number *</label>
            <input
              style={{
                ...styles.input,
                ...(inputFocus ? styles.inputFocus : {})
              }}
              type="text"
              placeholder="Enter username or userID"
              value={searchUserId}
              onChange={(e) => {
                setSearchUserId(e.target.value);
                setSearchedUser(null);
                setUserIdToRemove(null);
              }}
              onFocus={() => setInputFocus(true)}
              onBlur={() => setInputFocus(false)}
              disabled={loading}
            />
          </div>
          <button
            type="button"
            style={{
              ...styles.btn,
              opacity: loading ? 0.65 : 1,
              pointerEvents: loading ? "none" : "auto"
            }}
            onClick={checkuser}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>
        <div>
          {/* User Preview */}
          {searchedUser === "notfound" && (
            <div style={styles.error}>❌ No user found!</div>
          )}
          {searchedUser && searchedUser !== "notfound" && (
            <div style={styles.previewUser}>
              <img
                src={
                  searchedUser.picture
                    ? process.env.REACT_APP_BASEURL + searchedUser.picture
                    : "https://ui-avatars.com/api/?name=" +
                      encodeURIComponent(searchedUser.username)
                }
                alt="User"
                style={styles.previewImg}
              />
              <span>
                {searchedUser.username}
                <br />
                <span style={{ color: "#1976d2", fontWeight: 400 }}>
                  {searchedUser.name}
                </span>
              </span>
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <button
            type="reset"
            style={styles.btnCancel}
            onClick={() => {
              setSearchUserId("");
              setSearchedUser(null);
              setUserIdToRemove(null);
            }}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{
              ...styles.btn,
              background: "linear-gradient(90deg,#32c766 70%,#27ae60 100%)",
              opacity: (!userIdToRemove || loading) ? 0.65 : 1,
              pointerEvents: (!userIdToRemove || loading) ? "none" : "auto"
            }}
            disabled={!userIdToRemove || loading}
          >
            {loading ? "Adding..." : "Add as Test User"}
          </button>
        </div>
      </form>

      <div style={{
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 1px 6px #0d47a11a",
        padding: 24,
        marginTop: 12
      }}>
        <div style={{ ...styles.heading, fontSize: 23, marginBottom: 15 }}>
          <span role="img" aria-label="list">📝</span> Test Users List
        </div>
        <div style={{ width: "100%", overflowX: "auto", borderRadius: 12 }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Sr.</th>
                <th style={styles.th}>UserName</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>
            <tbody>
              {fetching ? (
                <tr>
                  <td colSpan={3} style={{
                    ...styles.td,
                    textAlign: "center",
                    color: "#0057e7",
                    fontWeight: 600
                  }}>
                    Fetching...
                  </td>
                </tr>
              ) : remRanks && remRanks.length > 0 ? (
                remRanks.map((item, i) => (
                  <tr
                    key={item._id}
                    style={i % 2 === 0 ? styles.trEven : styles.trOdd}
                    onMouseEnter={e => e.currentTarget.style.background = "#e3f2fd"}
                    onMouseLeave={e => e.currentTarget.style.background = (i % 2 === 0 ? "#f8fbff" : "#fff")}
                  >
                    <td style={styles.td}>{i + 1}</td>
                    <td style={{ ...styles.td, fontWeight: 500, color: "#1565c0" }}>
                      {item?.userId?.username}
                    </td>
                    <td style={styles.td}>
                      <button
                        style={{
                          ...styles.btn,
                          ...styles.btnDanger,
                          opacity: loading ? 0.65 : 1,
                          pointerEvents: loading ? "none" : "auto"
                        }}
                        onClick={() => {
                          if (window.confirm("Are you sure you want to Delete?"))
                            deleteRemovedRanks(item?._id);
                        }}
                        disabled={loading}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} style={{
                    ...styles.td,
                    textAlign: "center",
                    color: "#666"
                  }}>
                    No Test Users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
